<dx-load-panel [visible]="loadPanelVisible"></dx-load-panel>

<div class="direct-layout">

  <div class="menu">
    <dx-box direction="row" height="51px" width="100%">
      <dxi-item [ratio]="8">
        <div style="width: 150px; padding-left: 10px; padding-top: 4px;">
          <a style="cursor: pointer;" (click)="router.navigate(['/home'])"><img style="" src="./assets/images/ams_logo1.png" /></a>
        </div>
      </dxi-item>
      <dxi-item [ratio]="70" *ngIf="isValid">
        <dx-scroll-view style="display:block;" direction="horizontal" [useNative]="false" [scrollByContent]="true">
          <dx-menu class="main-menu"
                   [dataSource]="mainMenuItems"
                   [showFirstSubmenuMode]="showFirstSubmenuModes"
                   hideSubmenuOnMouseLeave="true"
                   displayExpr="Name"
                   (onItemClick)="itemClick($event)">
          </dx-menu>
        </dx-scroll-view>
      </dxi-item>
      <dxi-item [ratio]="6" *ngIf="isValid">
        <dx-scroll-view style="display:block;" direction="horizontal" [useNative]="false" [scrollByContent]="true">
          <app-transaction-error></app-transaction-error>
        </dx-scroll-view>
      </dxi-item>
      <dxi-item [ratio]="16" *ngIf="isValid">
        <dx-scroll-view style="display:block;" direction="horizontal" [useNative]="false" [scrollByContent]="true">
          <div class="user">
            <div style="float: right; margin-top:1px; margin-right:1px;">
              <dx-menu class="user-menu"
                       [items]="userMenuItems"
                       showFirstSubmenuMode="onClick"
                       hideSubmenuOnMouseLeave="true"
                       displayExpr="functionName"
                       (onItemClick)="userItemClick($event)">
              </dx-menu>
            </div>
          </div>
        </dx-scroll-view>
      </dxi-item>
    </dx-box>
  </div>


  <div class="heading" *ngIf="router.url.search('modules') === -1">
    <table *ngIf="isValid" style="border-spacing: 0;">
      <tbody>
        <tr>
          <td style="padding-top: 14px;"><span class="navigationInfoClass" [style.padding-left]="navigationInfoClassPaddingLeft"> {{ navigationInfoModule }} {{ navigationInfoFunction }} </span></td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Temporarily disable sidemenu until we have built it fully dynamical server side... -->
  <!-- <app-side-menu *ngIf="isValid && router.url !== '/home'"></app-side-menu> -->
  <!--<a class="side-menu-open fas fa-bars" ></a>-->

</div>

<!-- Popup for changing password -->
<app-change-password *ngIf="changePasswordPopupVisible" [popupVisible]="changePasswordPopupVisible" (closed)="changePasswordPopupVisible = false"></app-change-password>

<!-- Popup for selected printer -->
<dx-popup [width]="1100"
          [height]="500"
          [showTitle]="true"
          [title]="selectPrinterPopupTitle"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          container=".dx-viewport"
          [(visible)]="selectPrinterPopupVisible"
          (onShowing)="selectPrinterPopupOnShowing($event)"
          (onShown)="selectPrinterPopupOnShown($event)">
  <app-shared-printer-settings #thePrinterSetting></app-shared-printer-settings>
</dx-popup>


